<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
        <div class="containar">
          <div class="content-title">
            <h2>
              半透明コメント
            </h2>
            <p>半透明コメントの色をカスタマイズできます。</p>
            <p>生成したコードをOBSのカスタムCSSに追記してください。</p>
          </div>
          <div class="contents-block">
          <div class="transparent_line__left">
            <span
              class="transparent_line__name"
              :style="nameStyle"
            >
              視聴者さん
            </span>
            <span
              class="transparent_text"
              :style="transparentTextStyle"
            >
              Hello🐟
            </span>
            <span
              class="transparent_line__name"
              :style="nameStyle"
            >
              視聴者さん
            </span>
            <span
              class="transparent_text"
              :style="transparentTextStyle"
            >
              いい天気ですね
            </span>
          </div>
          <div class="set">
            <h3>カラー選択</h3>
            <div class="color-picker-grid">
              <div class="color-picker-column">
                <h4>メインカラー</h4>
                <div class="color-picker-wrapper">
                  <chrome-picker :value="mainColor" v-model="mainColor"></chrome-picker>
                </div>
              </div>
            </div>
            
            <h3>コピペ用CSS</h3>
            <div class="url-description">
              <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
            </div>
            <div class="url-container">
              <textarea id="target" readonly class="url-input textarea" v-model="generatedCSS" />
              <button @click="copy" class="url-copy-btn">
                <span>コピー</span>
              </button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue";

export default {
  components: {
    secondHeader,
    sidebar,
    'chrome-picker': Chrome,
  },
  data() {
    return {
      mainColor: {
            hex: "#4EADE7",
            hex8: '#4EADE7',
            hsl: { h: 204, s: 77, l: 61, a: 1 },
            rgba: { r: 78, g: 173, b: 231, a: 1 },
            a: 1,
        },
      generatedCSS: '',
    };
  },

  mounted() {
    this.generateCSS();
  },
  computed: {
    transparentTextStyle() {
      return {
        background: `rgba(${this.mainColor.rgba.r}, ${this.mainColor.rgba.g}, ${this.mainColor.rgba.b}, 0.2)`,
        border: `3px solid ${this.mainColor.hex}`,
        color: this.mainColor.hex,
      };
    },
    nameStyle() {
      return {
        color: this.mainColor.hex,
      };
    },
  },
  watch: {
    mainColor: {
      handler() {
        this.generateCSS();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    generateCSS() {
        this.generatedCSS = `:root {--main-color-r: ${this.mainColor.rgba.r};--main-color-g: ${this.mainColor.rgba.g};--main-color-b: ${this.mainColor.rgba.b};}`;
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.generatedCSS);
        } catch (err) {
        console.error('コピーに失敗しました:', err);
        }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kiwi+Maru&family=Single+Day&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 60px 0 60px 1.82%;
}

.transparent_contents-block{
  margin: 18px auto;
  padding: 24px 62px;
  background-color: #f1dfd0;
}
.m-form-text{
    width: 80%;
  height: 42px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
    height: 32px;
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}
.copy-btn:active {
  transform: scale(0.95);
  background-color: #ccc;
}

label {
  margin-right: 10px;
}


.heart_editor{
    margin-top: 24px;
}
/* コメントプレビュー */

.transparent_line__left{
  flex: 1;
  max-width: 420px;
  min-width: 320px;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.transparent_text {
    font-weight: bold;
    border-radius: 25px;
    padding: 12px 24px 12px 24px;
    margin-bottom:0;
    display: block;
    line-height: 1!important;
}

.transparent_line__name{
  display: block;
  font-size: 12px !important;
  font-weight: semi-bold;
  padding: 0px 8px 0 8px;
  margin-top: 12px;
  margin-left: 15px;
  margin-bottom: 4px;
}

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  min-width: 0;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0;
  }
  
  .transparent_line__left {
    margin-top:24px;
    margin-left: 0;
  }
}

.set{
  flex: 1;
  max-width: 420px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-left:12px;
}

/* Color Picker Grid Layout */
.color-picker-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 12px;
}

.color-picker-column {
  min-width: 0;
}

.color-picker-column h4 {
  font-size: 12px;
  margin: 0 0 8px 0;
  color: #4a5568;
  font-weight: 600;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 0;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

.color-picker-wrapper .vc-hue-pointer,
.color-picker-wrapper .vc-alpha-pointer {
  width: 16px;
  height: 16px;
}

.color-picker-wrapper .vc-hue-picker,
.color-picker-wrapper .vc-alpha-picker {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-wrapper .vc-saturation-pointer {
  width: 14px;
  height: 14px;
}

.color-picker-wrapper .vc-saturation-circle {
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 76px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}
</style>
